import { faCheck, faHome, faMoneyBill1Wave, faQrcode, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { Button, Card, Form, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import auxService from "../../services/AuxService";
import { formatMoeda } from "../../utils/utils";
import { AuthContext } from "../../contexts/AuthContext";

interface Tenant {
    id: number;
    grupo: string;
    name: string;
    data_vencimento: string;
    limite_empresas: number;
    total: number;
    empresas: Empresa[],
    active: boolean;
    mensalidades: any[];
    mensalidade_licencas: any[];
    pagamentos: any[];
    vencido: boolean;
}

interface Empresa {
    name: string;
    cnpj: string;
    insc_estadual: string;
    fone: string;
    celular: string;
}
const initial: Tenant = {
    id: 0,
    grupo: '',
    name: '',
    data_vencimento: '',
    total: 0,
    empresas: [],
    limite_empresas: 0,
    active: false,
    mensalidades: [],
    pagamentos: [],
    mensalidade_licencas: [],
    vencido: false
};

interface QrCodeProps {
    qrcode: string;
    image: string;
    documento: string;
    valor: number;
}

export default function IndexLicenca() {

    const [tenant, setTenant] = useState<Tenant>(initial);
    const authContext = useContext(AuthContext);

    const navigate = useNavigate();

    useEffect(() => {
        const requestInterval = setInterval(() => {

            if (tenant.mensalidade_licencas[0]?.documento !== undefined &&
                tenant.mensalidade_licencas[0]?.documento !== "" &&
                tenant.mensalidade_licencas[0].status === "ATIVA"

            ) {
                auxService.getStatusAssinatura(tenant.mensalidade_licencas[0]?.documento)
                    .then(res => {
                        if (res?.status === "CONCLUIDA") {
                            navigate('/dashboard');
                            if (res.empresa) {
                                authContext?.updateStatusEmpresa(res.empresa.id.toString(), res.empresa.active)
                            }

                        }
                    }).catch(error => {
                        console.log(error);
                    });
            }
        }, 10000); //10s

        return () => clearInterval(requestInterval);
    }, [tenant?.mensalidade_licencas]);

    useEffect(() => {
        fetchTenant();
    }, []);

    const fetchTenant = async () => {
        auxService.getTenant().then(res => {
            setTenant(res);
        });
    }

    const openQrCode = (value: QrCodeProps) => {
        navigate('/qrcode', {
            state: {
                qrcode: value.qrcode,
                image: value.image,
                documento: value.documento,
                valor: value.valor,
                tipo: 'licenca'
            }
        });
    }

    return (
        <div className="row ">
            <div className="d-flex justify-content-center align-items-center vh-100" >
                <div className="col-md-6">

                    <Form>
                        <Card className="card-success card-outline">

                            <Card.Header className="d-flex justify-content-between">
                                <Card.Title>
                                    Compra de Licença
                                </Card.Title>
                            </Card.Header>

                            <Card.Body>

                                <Table striped bordered hover size="sm" >
                                    <thead >
                                        <tr>
                                            <th>CNPJ Raiz</th>
                                            <th>Nome do Tenant</th>
                                            <th>Num. licenças</th>
                                            <th>Situação</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider">
                                        {tenant.id > 0 && (
                                            <tr key={tenant.id}>
                                                <td>{tenant.grupo}</td>
                                                <td>{tenant.name}</td>
                                                <td className="text-center">{tenant.limite_empresas}</td>
                                                <td className="text-center">{
                                                    tenant.active ?
                                                        <FontAwesomeIcon className="text-success" icon={faCheck} /> :
                                                        <FontAwesomeIcon className="text-danger" icon={faXmark} />
                                                }
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>

                                <Table striped bordered hover className="mb-0" size="sm">
                                    <thead >
                                        <tr>
                                            <th className="text-center">Tipo</th>
                                            <th className="text-center">Data pagamento</th>
                                            <th className="text-center">Valor</th>
                                            <th className="text-center">Status</th>
                                            <th className="text-center">QRCode</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider">
                                        {tenant.mensalidade_licencas?.map((p) =>
                                        (
                                            <tr key={p.id}>
                                                <td className="text-center">{p?.tipo_assinatura}</td>
                                                <td className="text-center">{p?.data_pagamento}</td>
                                                <td className="text-center">{formatMoeda(p?.valor)}</td>
                                                <td className="text-center">{p?.status}</td>
                                                <td className="text-center">
                                                    {p.status === 'ATIVA' && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0"
                                                            onClick={() => openQrCode(
                                                                {
                                                                    documento: p.documento,
                                                                    image: p.image_qrcode,
                                                                    qrcode: p.qrcode,
                                                                    valor: p.valor
                                                                }
                                                            )}
                                                        >
                                                            <FontAwesomeIcon icon={faQrcode} />
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                        )}
                                    </tbody>
                                </Table>
                            </Card.Body>

                            <Card.Footer className="d-flex justify-content-between">
                                <Link to="/empresa" className="">
                                    <Button variant="secondary"
                                        className=""> <FontAwesomeIcon icon={faHome} /> Voltar
                                    </Button>
                                </Link>

                                <Link to="/licenca/create" className="">
                                    <Button variant="primary" className="">
                                        <FontAwesomeIcon icon={faMoneyBill1Wave} /> Comprar licença
                                    </Button>
                                </Link>
                            </Card.Footer>
                        </Card>
                    </Form>
                </div>
            </div>
        </div>
    )
}